import React from "react";
import { PaymentsRoutesResponse } from "src/api";
import AlfredWithdrawalForm from "./AlfredWithdrawalForm";
import "./withdrawal-form.scss";

/**
 * Withdrawal entry point for Alfred tenants. The widget is bound to a single
 * payment route per session and Alfred is the only PSP rendered here, so this
 * delegates straight to the Alfred form. CXM does not pass through this
 * component at all — its page renders `CxmWithdrawalForm` directly, which is
 * what keeps the two providers from leaking into each other.
 *
 * `paymentsRoutes` is kept for signature compatibility with the page loader.
 */
const WithdrawalForm: React.FC<{
  paymentsRoutes: PaymentsRoutesResponse;
}> = (): JSX.Element => {
  return <AlfredWithdrawalForm />;
};

export default WithdrawalForm;
